import React, { Component } from 'react'
import { FilterDropdown } from './'
import { FilterStyle } from './../styles'
import { withResize } from './../hoc/withResize'

class Filter extends Component {
  state = {
    isOpen: null,
    mobileOpen: false,
    filtering: [],
  }

  componentDidMount() {
    this.getFilter(this.props.filters)
  }

  callBackFilter = () => {
    this.props.filters(this.state.filter)
  }

  componentWillReceiveProps({filters}) {
    if (filters !== this.props.filters) {
      this.getFilter(filters)
    }
  }

  getFilter = (filters) => {
    if (filters && Object.keys(filters).length > 0){
      const nArr = []
      let i = 0
      Object.keys(filters).map((filter, index) => {
        nArr.push({name: filter, items: filters[filter]})
        i = index
        if (i === Object.keys(filters).length - 1) {
          this.setState({ filters: nArr })
        }
        return filter
      })
    }
  }

  filtering = (filters, category) => {
    let nFilters = this.state.filtering
    
    if (filters.length > 0) nFilters[category] = filters
    else delete nFilters[category]
    this.setState({
      filtering: {
        ...nFilters,
      }
    }, () => {
      this.props.filtering(this.state.filtering)
    })
  }

  callbackOpen = (n) => {
    this.setState({ isOpen: n !== this.state.isOpen ? n : null })
  }

  handlerClick = (e) => {
    e.preventDefault()
    this.setState({ mobileOpen: !this.state.mobileOpen})
  }

  static defaultProps = {
    dark: false
  }

  render () {
    const { filters, isOpen, mobileOpen } = this.state
    const { dark, viewport } = this.props
    
    return (
      <div className={`filter ${FilterStyle(mobileOpen, dark)} flex`}>
        <div className="filter-item filter-focus" onClick={this.handlerClick}>
          <span className='filter-label'> { viewport.isMobile ?  'Filters' : 'Filter by'}</span>
          {
            viewport.isMobile && <span className='filter-close'></span>
          }
        </div>
        <ul className="reset flex items-center filter-list">
          {
            filters && filters.map((filter, index) => (
              <li key={index} className="filter-item">
                <FilterDropdown callbackFilters={this.filtering} toggleOpen={this.callbackOpen} id={index} isOpen={isOpen !== null && index === isOpen} lists={filter.items} label={filter.name} dark={dark} />
              </li>
            ))
          }
        </ul>
      </div>
    )
  }
}

export default withResize(Filter)


// WEBPACK FOOTER //
// ./src/components/Filter.js